<app-consult-note-select-specialty
  [capture]="capture"
  [patientAttachment]="selectedAttachment"
/>
<app-validate-prescriber-match
  [capture]="capture"
  [patientAttachment]="selectedAttachment"
  />
<app-validate-patient-match
  [capture]="capture"
  [patientAttachment]="selectedAttachment"
  />
<app-validate-specialist-encounter
  [capture]="capture"
  [patientAttachment]="selectedAttachment"
  />
<app-validate-drug-details
  [capture]="capture"
  [patientAttachment]="selectedAttachment"
  />
